import ContactUsForm, {
	FormIdType,
} from "@components/BasicComponents/Forms/ContactUsForm/ContactUsForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import useHash from "@hooks/useHash"
import {useRouter} from "next/router"
import React, {useEffect} from "react"

import styles from "./BookADemoSection.module.scss"

type Props = {}

const BookADemoSection = (props: Props) => {
	const hash = useHash()
	const router = useRouter()
	const {changeLocale: changeLocaleCustome} = useLocale()

	useEffect(() => {
		changeLocaleCustome(
			router.locale === "fi" || router.locale === "en"
				? router.locale
				: "en",
		)
	}, [router])

	let formId: FormIdType

	let text: {
		title: string
		text: string
	}

	switch (hash) {
		case "starter":
			formId = FormIdType.STUDIO_STARTER
			text = {
				title: "Request a demo",
				text: "Let us walk you through Dream Broker Studio Starter Edition",
			}
			break
		case "team":
			formId = FormIdType.STUDIO_TEAM
			text = {
				title: "Request a demo",
				text: "Let us walk you through Dream Broker Studio Team Edition",
			}
			break
		case "business":
			formId = FormIdType.STUDIO_BUSINESS
			text = {
				title: "Request a demo",
				text: "Let us walk you through Dream Broker Studio Business Edition",
			}
			break
		case "enterprise":
			formId = FormIdType.STUDIO_ENTERPRISE
			text = {
				title: "Request a demo",
				text: "Let us walk you through Dream Broker Studio Enterprise Edition",
			}
			break
		default:
			formId = FormIdType.STUDIO_DEFAULT
			text = {
				title: "Request a demo for our products",
				text: "Let us walk you through Dream Broker Studio and #One",
			}
			break
	}

	return (
		<section id={"book-a-demo"}>
			<div className={styles.textContainer}>
				<ContainerWrapper style={{position: "relative"}}>
					<Separator className={styles.textWrapper}>
						<Typography
							content={text.title}
							variant={Variant.SectionTitle}
							as={"h1"}
						/>
						<Typography
							content={text.text}
							variant={Variant.SectionSubtitle}
						/>
					</Separator>
				</ContainerWrapper>
			</div>

			<div className={styles.bottomSection}>
				<ContainerWrapper style={{position: "relative"}}>
					<ContactUsForm
						container={{
							className: styles.formContainer,
						}}
						form={formId}
					/>
				</ContainerWrapper>
			</div>
		</section>
	)
}

export default BookADemoSection
